<mat-accordion>
  <mat-expansion-panel *ngFor="let reise of items | async">
    <mat-expansion-panel-header>
      <mat-panel-title>{{reise.name}}</mat-panel-title>
      <mat-panel-description>{{reise.dateString}}</mat-panel-description>
    </mat-expansion-panel-header>
    <p *ngIf="reise.schlagworte" [innerHTML]="reise.schlagworte" class="mat-body-2"></p>
    <p *ngIf="reise.beschreibung" [innerHTML]="reise.beschreibungHTML"></p>
    <p [innerHTML]="reise.unterkunftHTML"></p>
    <div *ngIf="reise.kategorien.length">
      Preise
      <ul *ngIf="reise.kategorien">
        <li *ngFor="let kategorie of reise.kategorienWithoutHidden">
          {{kategorie | namePreis}}
          <ng-container *ngIf="kategorie.capacity">
            ({{kategorie.capacity.buchungsstandText}})
          </ng-container>
        </li>
        <li *ngIf="reise.kurtaxe">zzgl. Kurtaxe (Pflichtabgabe {{reise.kurtaxe | preis}}): zahlbar bequem per Vorkasse (alternativ selbstständig im Hotel)</li>
      </ul>
    </div>
    <p [innerHTML]="reise.skigebietHTML"></p>
    <div *ngIf="reise.kurseWithoutNull">
      Guiding (optional)
      <ul>
        <li *ngFor="let kurs of reise.kurseWithoutNull">{{kurs | namePreis}}</li>
      </ul>
    </div>
    <ng-container *ngIf="service.env.buchungEnabled">
      <div *ngIf="reise.buchbar">
        Buchungsstand: {{reise.buchungsstandText}}
      </div>
      <mat-action-row style="justify-content: flex-start">
        <button mat-button color="primary" routerLink="/buchung" [disabled]="!reise.buchbar">{{reise.buchenButtonText}}</button>
      </mat-action-row>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>

<br>
<mat-card>
  <mat-card-header>
    <mat-card-title>Hinweise</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <!--<app-corona-hinweis></app-corona-hinweis>-->
    Leistungen bei allen Busreisen
    <ul>
      <li>Top ausgestattete Busse der Firma Friedel Reisen GbR</li>
      <li>Reichhaltiges Bordfrühstück auf der Anreise</li>
      <li>Aufmerksame und höchst bemühte Reiseleitung, teilweise durch Snowboardlehrer (Doppelfunktion)</li>
      <li>Getränke (Wasser, Limo, Bier, Sekt) 1,50€ - 2,50€, ger. Bratwurst im Semmel 3€, siehe <a href="/assets/download/Board-Karte_26.jpeg" target="_blank">Board-Karte</a></li>
    </ul>
    <mat-divider></mat-divider>
    <br>
    Sonstiges
    <ul>
      <li [innerHTML]="texte.hinweisVermittlung()"></li>
      <li>Der Kinder- und Jugendpreis ist nur gültig, wenn dies bei Buchung angegeben wird und das Alter während der Reise durch einen Ausweis bzw. dessen Kopie nachweisbar ist.</li>
      <li>5€ Kurtaxe wird im Bus eingesammelt</li>
      <li>Zustiege: <a href="https://www.google.com/maps/d/edit?mid=12T0guQ0heMdZeC5HxpVKl7ANqN3ZNQs&usp=sharing" target="_blank">Google Maps Karte</a></li>
    </ul>
  </mat-card-content>
</mat-card>
